import React, { useMemo } from 'react';

import { When } from 'react-if';

import { Box } from '@nerdwallet/currency/components/Box';
import { Stack } from '@nerdwallet/currency/components/Stack';
import { Text } from '@nerdwallet/currency/components/Text';

import { colors } from '@nerdwallet/base-styles/variables';

import styles from './progress-bar.module.scss';

interface Props {
  backgroundColor?: string;
  barColor?: string;
  denominator?: number;
  height?: number;
  label?: string;
  numerator?: number;
  rounded?: boolean;
}

const ProgressBar: React.FC<Props> = ({
  backgroundColor = colors['neutral-lightest'],
  barColor = colors['green-light'],
  denominator,
  height = 6,
  label,
  numerator,
  rounded = false,
  ...boxProps
}) => {
  const percent = useMemo(
    () => (denominator === 0 ? 0 : (numerator / denominator) * 100),
    [denominator, numerator],
  );

  return (
    <Box {...boxProps}>
      <Stack spacing="3">
        <When condition={!!label}>
          <Text light>{label}</Text>
        </When>
        <div
          className={styles.progressBarContainer}
          style={{
            backgroundColor,
            height: `${height}px`,
            borderRadius: rounded ? `15px` : '0',
          }}
        >
          <div
            className={styles.progressBar}
            style={{
              backgroundColor: barColor,
              height: `${height}px`,
              width: `${percent}%`,
              borderRadius: rounded ? `15px` : '0',
            }}
          />
        </div>
      </Stack>
    </Box>
  );
};

export default ProgressBar;
